'use client';

export function getTrpcUrl() {
  if (!process.env.NEXT_PUBLIC_API_URL) {
    throw new Error('NEXT_PUBLIC_API_URL is not defined');
  }

  return `${getApiUrl()}/trpc`;
}

export function getStage() {
  if (!process.env.NEXT_PUBLIC_STAGE) {
    throw new Error('NEXT_PUBLIC_STAGE is not defined');
  }

  return process.env.NEXT_PUBLIC_STAGE;
}

export function getApiUrl() {
  if (!process.env.NEXT_PUBLIC_API_URL) {
    throw new Error('NEXT_PUBLIC_API_URL is not defined');
  }

  if (process.env.NODE_ENV === 'development' && getStage() === 'dev') {
    return 'http://localhost:3101/api';
  }

  return process.env.NEXT_PUBLIC_API_URL;
}
